import { useState, useRef, useEffect } from 'react';

/**
 * Хук для управления сообщениями чата
 */
export const useChatMessages = () => {
  const [messages, setMessages] = useState([]);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const addMessage = (message) => {
    setMessages((prev) => [...prev, message]);
  };

  const updateLastMessage = (updater) => {
    setMessages((prev) => {
      const updated = [...prev];
      const lastIndex = updated.length - 1;
      if (updated[lastIndex]) {
        updated[lastIndex] = updater(updated[lastIndex]);
      }
      return updated;
    });
  };

  const removeLastMessage = () => {
    setMessages((prev) => {
      const updated = [...prev];
      updated.pop();
      return updated;
    });
  };

  return {
    messages,
    messagesEndRef,
    addMessage,
    updateLastMessage,
    removeLastMessage,
  };
};

